import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login, getDashboardRoute } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    
    if (result.success) {
      console.log('Connexion réussie, redirection immédiate vers:', result.redirect_url);
      // Redirection immédiate - ne pas passer par la page d'accueil
      const redirectPath = result.redirect_url || getDashboardRoute();
      console.log('Redirection vers:', redirectPath);
      navigate(redirectPath, { replace: true });
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  const quickLogin = async (testEmail, testPassword) => {
    setEmail(testEmail);
    setPassword(testPassword);
    setLoading(true);
    setError('');

    const result = await login(testEmail, testPassword);
    
    if (result.success) {
      console.log('Connexion rapide réussie, redirection immédiate vers:', result.redirect_url);
      // Redirection immédiate - ne pas passer par la page d'accueil
      const redirectPath = result.redirect_url || getDashboardRoute();
      console.log('Redirection vers:', redirectPath);
      navigate(redirectPath, { replace: true });
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Connexion FSF
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Système avec redirection automatique par zone
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <input
                type="email"
                required
                className="relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Adresse email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <input
                type="password"
                required
                className="relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="text-red-600 text-sm text-center">{error}</div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </div>
        </form>

        {/* Tests rapides */}
        <div className="mt-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Tests rapides :</h3>
          <div className="space-y-2">
            <button
              onClick={() => quickLogin('admin@fsf.com', 'password')}
              disabled={loading}
              className="w-full text-left px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
            >
              <div className="font-medium">Admin FSF</div>
          AdminContacts    <div className="text-sm text-gray-500">→ Dashboard Principal</div>
            </button>
            <button
              onClick={() => quickLogin('test.membre.cotonou@fsf.com', 'password')}
              disabled={loading}
              className="w-full text-left px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
            >
              <div className="font-medium">Membre Zone Cotonou</div>
              <div className="text-sm text-gray-500">→ Zone Dashboard</div>
            </button>
            <button
              onClick={() => quickLogin('test.moderateur.cotonou@fsf.com', 'password')}
              disabled={loading}
              className="w-full text-left px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
            >
              <div className="font-medium">Modérateur Zone Cotonou</div>
              <div className="text-sm text-gray-500">→ Zone Dashboard</div>
            </button>
            <button
              onClick={() => quickLogin('apz.calavi@fsf.com', 'password')}
              disabled={loading}
              className="w-full text-left px-3 py-2 border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
            >
              <div className="font-medium">APZ Zone Calavi</div>
              <div className="text-sm text-gray-500">→ Zone Dashboard</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;